import { buildersSelector } from './buildersSelector';
import { sellersSelector } from './sellersSelector';
import { TApplicationState } from 'shared/types/redux';
import { hasValidPhone, isLeadFactory } from '../../utils/agent';

export const hasContactsSelector = (state: TApplicationState): boolean => {
  const builders = buildersSelector(state);
  const sellers = sellersSelector(state);

  /* oxlint-disable typescript/no-explicit-any */
  const buildersWithPhones = builders.filter(hasValidPhone as any);
  const sellersWithPhones = sellers.filter(hasValidPhone as any);
  const leadFactory = sellers.find(isLeadFactory);
  const contactsAmount = buildersWithPhones.length + sellersWithPhones.length;

  return Boolean(leadFactory || contactsAmount > 0);
};
